import Model from './model.js'

export default class ProspectDeal extends Model {
}